// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@nrwl/web/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".blockHeading_heading__Iy3EU {\n  padding: 4px 10px;\n  font-size: 18px;\n  background-color: var(--primary-dark);\n  color: var(--text-primary);\n  text-transform: uppercase;\n  border-radius: 8px 8px 0 0;\n}", ""]);
// Exports
exports.locals = {
	"heading": "blockHeading_heading__Iy3EU"
};
module.exports = exports;
